var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SearchObject', {
    ref: "search",
    attrs: {
      "additional-params": Object.assign({
        ordering: 'order_id'
      }, _vm.additionalParams),
      "allow-create": _vm.allowCreate,
      "autofocus": _vm.autofocus,
      "base-url": _vm.baseUrl,
      "create-label": _vm.$translate('create_a_order'),
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "item-text": _vm.itemText,
      "label": _vm.label || _vm.$translate('select_order'),
      "readonly": _vm.readonly,
      "required": _vm.required,
      "value": _vm.value,
      "error-messages": _vm.errorMessages,
      "dense": _vm.dense,
      "outlined": _vm.outlined
    },
    on: {
      "create": _vm.createOrder,
      "input": function input($event) {
        return _vm.$emit('input', $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.itemText(item)) + " ")];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }